import { render, staticRenderFns } from "./translation-editor.vue?vue&type=template&id=027e6bd5&scoped=true"
import script from "./translation-editor.vue?vue&type=script&lang=js"
export * from "./translation-editor.vue?vue&type=script&lang=js"
import style0 from "./translation-editor.vue?vue&type=style&index=0&id=027e6bd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e6bd5",
  null
  
)

export default component.exports